import { getField, updateField } from "vuex-map-fields";
import Cookies from "js-cookie";
export default {
    namespaced: true,
    state: {
        showChatPopup: false,
        inputSearchQuery: '',
        minimiseValue: true,
        iframeLoaded: false,
        iframeRef: null,
        tgptIframeUrl: tgptIframeUrl,
        Products:[],
        skuParams:null,
        isIframeInitialLoad:true,
        show: false,
        type: 'success',
        message: '',
        sessionID:"",
        _timeout: null, // It's better to keep the timeout within the store state
        isQueryType: "search"
    },
    actions: {
        openIframe({ state,commit,dispatch }) {
            Cookies.set('chat_session_started', 'true', { path: '/' });
            commit('OPEN_IFRAME')
            commit('SET_IFRAME_LOADED', true);
            dispatch('postMessageToIframe', {
                type: 'scrubbing_data',
                data: { value: Cookies.get('skuParams') }
            });
        },
        closeIframe({ commit }) {
            Cookies.set('chat_session_started', 'false', { path: '/' });
            Cookies.set('chat_minimise_state', 'false', { path: '/' });
            commit('CLOSE_IFRAME')
            commit('SET_MINIMISE', false);
            commit('SET_IFRAME_LOADED', false);
        },
        checkSessionCookie({ commit, dispatch}) {
            const sessionCookie = Cookies.get('chat_session_started');
            if (sessionCookie && sessionCookie !== 'false') { 
                commit('OPEN_IFRAME');
              
            } else {
                commit('CLOSE_IFRAME');
            }
            const cookieValue = Cookies.get('chat_minimise_state');
            const finalValue = cookieValue !==undefined  ? cookieValue === 'true' : true
            commit('SET_MINIMISE', finalValue);
            
        },
        updateInputSearchQuery({ commit }, payload) {
            let inputText = payload?.query ?? ''
            let givenQueryType = payload?.type ?? 'search';
            commit('UPDATE_SEARCH_QUERY', inputText);
            commit('UPDATE_GIVEN_TYPE', givenQueryType);
        },
        setIframeRef({ commit }, el) {
            commit('SET_IFRAME_REF', el);
        },
        setIframeLoaded({ commit }, status) {
            commit('SET_IFRAME_LOADED', status);
        },
        handleMiniseAndMaxiseEvent({ commit, dispatch }, givenValue) {
            commit('SET_MINIMISE', givenValue);
            dispatch('postMessageToIframe', {
                type: 'minimize_Maxmise',
                data: { value: !givenValue }
            });
        },
        updateMiniseAndMaximiseValue({ commit }) {
            commit('TOGGLE_MINIMISE');
        },
        postMessageToIframe({ state }, payload) {
            const iframe = state.iframeRef;
            const domain = state.tgptIframeUrl
            if (state.iframeLoaded && iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage(payload, domain);
            } else {
                console.warn('Iframe not loaded or missing ref');
            }
        },
        setProducts({state,commit},payload) {
            commit('SET_PRODUCTS',payload);
            return true
        },
        open({state, commit, dispatch },payload ) {
            commit('SET_TYPE', payload.type);
            commit('SET_MESSAGE', payload.message);
            commit('SET_SHOW', true);
            if (typeof window !== 'undefined' && window.innerWidth >= 768) {
                const header = document.getElementById('site-navigation');
                if (header) {
                    header.style.zIndex = '99999';
                }
            }
            clearTimeout(state._timeout);
            const timeout = setTimeout(() => {
              dispatch('close');
            }, 3000);
            commit('SET_TIMEOUT', timeout);
          },
          close({ state,commit }) {
            commit('SET_SHOW', false);
            if (typeof window !== 'undefined' && window.innerWidth >= 768) {
                const header = document.getElementById('site-navigation');
                if (header) {
                    header.style.zIndex = '';
                }
            }
            clearTimeout(state._timeout);
            commit('SET_TIMEOUT', null);
          },
          updateSessionId({commit},payload) {
            commit('UPDATE_SESSION_ID',payload);
        }
    },

    mutations: {
        updateField,
        OPEN_IFRAME(state) {
            state.showChatPopup = true
            state.iframeLoaded = true
        },
        CLOSE_IFRAME(state) {
            state.showChatPopup = false
            state.iframeLoaded = false

        },
        UPDATE_SEARCH_QUERY(state, value) {
            state.inputSearchQuery = value
        },
        SET_IFRAME_LOADED(state, value) {
            state.iframeLoaded = value;
        },
        SET_IFRAME_REF(state, value) {
            state.iframeRef = value;
        },
        SET_MINIMISE(state, value) {
            state.minimiseValue = value;
            Cookies.set('chat_minimise_state', value, { path: '/' });
        },
        TOGGLE_MINIMISE(state) {
            state.isIframeInitialLoad = false;
            state.minimiseValue = !state.minimiseValue;
            Cookies.set('chat_minimise_state', state.minimiseValue, { path: '/' });
        },
        SET_PRODUCTS(state,value) {
            state.Products = value.data || [];

            if(state.Products.length > 0) {
                state.skuParams =  state.Products
                                    .map(p => `skus=${encodeURIComponent(p.sku)}`)
                                    .join('&');
                Cookies.set('skuParams', state.skuParams, { path: '/' });
            }

        },
        SET_SHOW(state, show) {
            state.show = show;
          },
          SET_TYPE(state, type) {
            state.type = type;
          },
          SET_MESSAGE(state, message) {
            state.message = message;
          },
          SET_TIMEOUT(state, timeout) {
            state._timeout = timeout;
          },
          UPDATE_SESSION_ID(state,givenSessionID) {
            state.sessionID = givenSessionID;
          },
          UPDATE_GIVEN_TYPE(state,givenType) {
            state.isQueryType = givenType;
          }
    },

    getters: {
        getField,
    }
}